import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import { USER_LOCALE_STORAGE_KEY } from '~/shared/config/constants'
import { LocaleEnum } from '~/shared/config/enums'
import { storageGet } from '~/shared/lib/storage'
import { en, ru } from './translation'

export const DEFAULT_LOCALE = 'ru'

export const initI18n = async () => {
  const userLocale =
    storageGet<LocaleEnum>(USER_LOCALE_STORAGE_KEY) || DEFAULT_LOCALE

  i18next.use(initReactI18next).init({
    lng: userLocale,
    resources: {
      en: { translation: en },
      ru: { translation: ru },
    },
    interpolation: {
      escapeValue: false,
    },
  })
}
